<template>
    <div>
        <section class="itb-hero-cards">
            <div class="container">
                <div
                    v-for="category in graphicCategories"
                    class="itb-hero-card row d-flex align-content-center mx-0"
                    v-lazy:background-image="
                        category.image && !isResponsive
                            ? '/uploads/' + category.image
                            : '/images/articles/blank-bg.webp'
                    "
                >
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            category.image ? '/uploads/' + category.image : ''
                        "
                    ></div>
                    <div
                        :class="[
                            'col-12 col-md-6 text-nowrap',
                            category.id % 2 == 0 ? 'offset-md-6 mt-md-0' : ''
                        ]"
                    >
                        <div
                            :class="[
                                'itb-card',
                                category.id % 2 == 0 ? 'ml-auto right' : ''
                            ]"
                        >
                            <h2 v-html="$t('constants.' + category.name)"></h2>
                            <p
                                v-html="$t('constants.' + category.subtitle)"
                            ></p>
                            <router-link
                                :to="category.buttonLink"
                                :class="[
                                    'btn itb-btn-icon',
                                    category.id % 2 == 0
                                        ? 'btn-primary'
                                        : 'btn-secondary'
                                ]"
                            >
                                {{ $t("constants." + category.button) }}
                                <img
                                    src="/images/icons/4soft_icon_angle-right.svg"
                                    :alt="$t('home.i_want_to_know_more')"
                                    class="itb-icon itb-angle-right-icon"
                                />
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <router-view></router-view>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            pageParams: [],
            graphicCategories: [],
            isResponsive: false
        };
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    mounted() {
        axios
            .get("/getGraphicsPage")
            .then(response => {
                this.graphicCategories = response.data.graphicCategories;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    methods: {
        ...mapActions(["setPageParams"]),

        onResize() {
            if (window.innerWidth < 768) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        }
    }
};
</script>
